import { Icon, IconButton } from '@material-ui/core'
import { useSnackbar } from 'notistack';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DenseAppBar from '../../components/AppBar';
import Filters from '../../components/Filters'
import AlertModal from '../../components/Modal';
import PaginationControlled from '../../components/Pagination';
import Placeholder from '../../components/Skeleton';
import Functions from '../../helpers/Functions';
import { Reducers } from '../../Interfaces/Interfaces';
import { getAggregatorPOSTransactions } from '../../redux/actions/POSAction';
import PrimaryTheme from '../../Themes/Primary'
import "./pos.scss";
export default function POSTransactions() {
  const [searchState, setSearchState] = React.useState('');
  const transactions = useSelector((state: Reducers) => state.posTransactions);
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const agents = useSelector((state: Reducers) => state.agents);

  // const dashboard = useSelector((state: Reducers) => state.dashboard);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [typeState, setTypeStateChange] = React.useState(0);
  const [amount, setAmount] = React.useState('');
  const [exportAmount, setExportAmount] = React.useState('');
  const [transactionStatus, setTransactionStatus] = React.useState(0);
  const types = useSelector((state: Reducers) => state.transactionTypes);
  const [agent, setAgent] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [reference, setReference] = React.useState('');
  const [type, setType] = React.useState('0');
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);

  let list = transactions && transactions.items;
  let agentList: Array<any> = agents && agents.items;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter)
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };


  const handleDownload = () => {
    // setSubmitted(true);

    if (agent.length !== 0) {
      filter.agent = agent;
    }

    if (phone.length !== 0) {
      filter.phoneNumber = phone;
    }

    if (exportAmount.length !== 0) {
      filter.amount = exportAmount
    }

    if (reference.length !== 0) {
      filter.reference = reference;
    }

    if (type !== '0') {
      filter.transactionType = type;
    }

    if (endDate.length !== 0) {
      filter.dateCreatedFrom = startDate;
    }
    if (startDate.length !== 0) {
      filter.dateCreatedTo = endDate;
    }

    window.open(
      `https://pos-${process.env.REACT_APP_STAGE}-alb.bankly.ng/api/PosTransactionLog/downloadAggregatorReport/${user.id}/${JSON.stringify(filter)}`, '_blank',
    );

  };
  const reset = () => {
    setAgent('')
    setExportAmount("");
    setPhone('')
    setReference('')
    setType('0')
    setStartDate('')
    setEndDate('')
    setSubmitted(false);
  };


  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  }

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (event: React.MouseEvent<HTMLButtonElement> | null, value: any) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getAggregatorPOSTransactions(paginationConfig));
  };



  const handleRefresh = () => {
    dispatch({
      type: 'LOADING',
      payload: true
    });

    dispatch(getAggregatorPOSTransactions(paginationConfig));
  }

  React.useEffect(() => {
    dispatch({
      type: 'LOADING',
      payload: true
    });

    dispatch(getAggregatorPOSTransactions(paginationConfig));
    return () => {
      dispatch({
        type: 'POS_TRANSACTIONS',
        payload: {}
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page, searchState]);

  React.useEffect(() => {
    if (searchState.length >= 5) {
      filter.reference = searchState;

      dispatch({
        type: 'LOADING',
        payload: true
      });

      dispatch(getAggregatorPOSTransactions(paginationConfig));
      return () => {
        dispatch({
          type: 'POS_TRANSACTIONS',
          payload: {}
        })
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, searchState]);


  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

      } else {

        handleRefresh();


        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <React.Fragment>
      <div className="col-md-11 mr-auto ml-auto p-0" style={{
        height: 'auto',
        position: "relative",
      }}>
        <DenseAppBar
          onClick={() => history.goBack()}
          canGoBack
        />
      </div>
      <div className='col-md-12 pl-0 pr-0' style={{
        // overflow: "auto",
        backgroundColor: PrimaryTheme.white,
        // height: '100vh',
      }}>

        <div className="col-md-11 ml-auto mr-auto p-0" style={{
          backgroundColor: PrimaryTheme.white,
          height: '100vh',
          position: 'relative',
        }}>
          <div className="row">
            <div className="col">
              <h1 className="mb-5 rec-pos-title" style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                textTransform: "uppercase",
                fontSize: PrimaryTheme.fontSizes?.subtitle
              }}>Pos Transactions</h1>
            </div>
          </div>

          {/* cards  */}
          {/* <div className="row mb-5">
            <div className="col" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Terminal ID</h5>
              <h4 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                wordWrap: "break-word"
              }}>{dashboard.terminalId ? dashboard.terminalId : "-"}</h4>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>{dashboard.serialNumber ? "SN: " + dashboard.serialNumber : "-"}</h6>
            </div>

            <div className="col" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Assigned To</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.assignedToAgentTellerBy ? dashboard.assignedToAgentTellerBy : "-"}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>{dashboard.agentName ? dashboard.agentName : "-"}</h6>
            </div>

            <div className="col" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Status</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.targetStatusName ? dashboard.targetStatusName : "-"}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>Today</h6>
            </div>

            <div className="col" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Status</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.weeklyTargetStatusName ? dashboard.weeklyTargetStatusName : "-"}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>This Week</h6>
            </div>
 */}

          {/* </div> */}

          <div className="row mb-5">
            <div className="col-md-12">
              <Filters
                name="Export Transactions"
                hasDownloads
                onDownload={() => dispatch({
                  type: 'ALERT_MODAL',
                  payload: true
                })}
                hasSearch
                searchState={searchState}
                handleSearch={(e: any) => setSearchState(e.target.value)} />
            </div>
          </div>

          <div className="row " style={{ paddingBottom: "100px" }}>
            <div className="col-md-12 mb-3">

              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr>
                          <th scope="col">S/N</th>
                          <th scope="col">Type</th>
                          <th scope="col">Agent</th>
                          <th scope="col">Date</th>
                          <th scope="col">Reference</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Commission</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 && list?.map((item: any, index: number) => (
                          <tr key={index} onClick={() => history.push(`/pos-transactions/${item.id}`)}>
                            <th scope="row">{getIndexSeed(index)}</th>
                            <td style={{ display: "flex" }}>
                              <div className="row m-0 justify-content-start align-items-center">
                                <Icon fontSize="small" style={{
                                  color: PrimaryTheme.lightGreen,
                                  marginRight: 5
                                }}>fiber_manual_record</Icon>
                              </div>
                              {item.transactionTypeName}
                            </td>
                            <td>{item.agentName ? item.agentName : "-"}</td>
                            <td>{Functions.getDate(item.transactionDate)}</td>
                            <td>{item.reference ? item.reference : "-"}</td>
                            <td>{item.amount ? Functions.getCurrency(item.amount) : Functions.getCurrency("0")}</td>
                            <td>{item.aggregatorCommission ? Functions.getCurrency(item.aggregatorCommission) : Functions.getCurrency("0")}</td>
                            <td style={{ display: "flex" }}>
                              {item.status === 1 && <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 mr-1">{item.statusName}</span>}
                              {item.status === 2 && <span className="badge badge-pill badge-danger p-2 pl-3 pr-3 mr-1">{item.statusName}</span>}
                              {item.status === 3 && <span className="badge badge-pill badge-success p-2 pl-3 pr-3 mr-1">{item.statusName}</span>}

                              <IconButton size="small">
                                <Icon style={{
                                  color: PrimaryTheme.light,
                                }}>more_vert</Icon>
                              </IconButton>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 &&
                    <React.Fragment>
                      <p className='text-center mt-3 text-dark w-100'>No result</p>
                    </React.Fragment>

                  }

                  <div className='col-md-12 p-0'>
                    {transactions.total > pageSize && <PaginationControlled onPageSizeChange={handlePageSizeChange} onChange={handleChange} page={page} total={transactions.total && transactions.total} pageSize={pageSize} />}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>

                </React.Fragment>
              )}

            </div>
          </div>
        </div>

        <AlertModal showClose maxWidth="md">
          <div className="col-md-12 pl-5 pr-5 pb-5 text-center">
            <div className="col-md-12">
              <span className="badge-pill p-3 d-block col-7 ml-auto mr-auto" style={{
                background: PrimaryTheme.warn,
                fontFamily: PrimaryTheme.fonts?.MediumFont,
              }}>Download Transactions</span>
            </div>

            {/* <p className="mt-3 mb-5" style={{
              fontFamily: PrimaryTheme.fonts?.RegularFont,
              fontSize: 14,
              color: PrimaryTheme.light
            }}>{subtitle}</p> */}

            <div className="row m-0">

              <div className="col-md-3">
                <div className="form-group mt-4 text-left">
                  <label htmlFor="agent" style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}>Agent</label>
                  <select className="custom-select" id="agent" name="agent" value={agent} onChange={(e) => setAgent(e.target.value)}>
                    <option value="0">Select Agent</option>
                    {agentList && agentList.length !== 0 && agentList.map((item: any, index: number) => (
                      <option key={index} value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group mt-4 text-left">
                  <label htmlFor="phone" style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}>Phone Number</label>
                  <input
                    type='tel'
                    placeholder='Phone Number'
                    autoComplete="text"
                    id="phone"
                    value={phone}
                    inputMode="text"
                    onChange={e => setPhone(e.target.value)}
                    className="form-control"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      // background: "#F4F7FC"
                    }}
                  />
                </div>
              </div>

              <div className="col-md-3">

                <div className="form-group mt-4 text-left">
                  <label htmlFor="amount" style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}>Amount</label>
                  <input
                    type='number'
                    placeholder='Amount'
                    id="amount"
                    value={exportAmount}
                    inputMode="text"
                    onChange={e => setExportAmount(e.target.value)}
                    className="form-control"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      // background: "#F4F7FC"
                    }} />
                </div>
              </div>

              <div className="col-md-3">

                <div className="form-group mt-4 text-left">
                  <label htmlFor="reference" style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}>Transaction Reference</label>
                  <input
                    type='tel'
                    placeholder='Reference'
                    id="reference"
                    value={reference}
                    inputMode="text"
                    onChange={e => setReference(e.target.value)}
                    className="form-control" style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      // background: "#F4F7FC"
                    }} />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group mt-4 text-left">
                  <label htmlFor="type" style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}>Transaction Type</label>
                  <select
                    className="custom-select"
                    id="type" name="type"
                    value={type}
                    onChange={(e) => setType(e.target.value)}>
                    <option value="0">Select Type</option>
                    {types.length !== 0 && types.map((type: any, index: number) => (
                      <option key={index} value={type.id}>{type.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">

                <div className="form-group mt-4 text-left">
                  <label htmlFor="startDate" style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}>Start Date</label>
                  <input
                    type='date'
                    placeholder='Amount'
                    id="startDate"
                    value={startDate}
                    onChange={e => setStartDate(e.target.value)}
                    className="form-control" style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      // background: "#F4F7FC"
                    }} />
                </div>
              </div>


              <div className="col-md-3">

                <div className="form-group mt-4 text-left">
                  <label htmlFor="endDate" style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}>End Date</label>
                  <input
                    type='date'
                    placeholder='Amount'
                    id="endDate"
                    value={endDate}
                    onChange={e => setEndDate(e.target.value)}
                    className="form-control" style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      // background: "#F4F7FC"
                    }} />
                </div>
              </div>

              <div className="col-md-12 text-right">
                <button className="btn btn-light mr-1" type="reset" onClick={reset}>Reset</button>
                <button
                  disabled={
                    submitted ||
                    startDate === "" ||
                    endDate === ""
                  } onClick={handleDownload}
                  className="btn btn-success">{submitted ? "Downloading..." : "Download"}</button>
              </div>

            </div>
          </div>
        </AlertModal>

      </div>
    </React.Fragment >
  )
}
